import bankBICE from '../../banksPNG/bankBICE.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoBiceIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco BICE',
}: IconProps) => <img src={bankBICE} width={width} height={height} alt={alt} />;
